import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Slider from 'rc-slider';

import { formatNumber } from '../utils';

// rc-slider's onChange fires on every drag step; commit to filter state (which
// triggers a fetch) only on release via onChangeComplete, tracking the drag locally.
const RangeSliderRow = ({ slider, value, onCommit }) => {
  const [local, setLocal] = useState(value);
  useEffect(() => { setLocal(value); }, [value]);

  const active = local[0] > slider.min || local[1] < slider.max;
  return (
    <div className="ab-slider">
      <div className="ab-slider__head">
        <span className="ab-slider__title">{slider.title}</span>
        {active && (
          <button type="button" className="ab-reset" onClick={() => onCommit([slider.min, slider.max])}>Reset</button>
        )}
      </div>
      <div className="ab-slider__values">
        <span>{formatNumber(local[0])}</span>
        <span>{formatNumber(local[1])}{local[1] >= slider.max ? '+' : ''}</span>
      </div>
      <Slider
        range
        min={slider.min}
        max={slider.max}
        step={slider.step}
        value={local}
        allowCross={false}
        onChange={setLocal}
        onChangeComplete={onCommit}
      />
    </div>
  );
};
RangeSliderRow.propTypes = {
  slider: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
  onCommit: PropTypes.func.isRequired,
};

export default RangeSliderRow;
